import React from "react"
import { Link } from "gatsby"
import kebabCase from "lodash/kebabCase"
import styled from "styled-components"
import PropTypes from "prop-types"

const ContentWrapper = styled.div`
  display: inline-block;
  margin: 0 0.5rem 0.5rem 0;
  padding: 0.2rem 0.5rem;
  background-color: #ffcc06;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.8rem;
  font-family: 'Noto Sans KR', sans-serif;

  &:hover {
    background-color: #202c6a;
  }

  & a {
    color: white;
  }

  & a:hover {
    text-decoration: none;
  }
`

const TagItem = ({ name, count }) => {
  const countText = count === 0 ? "" : ` (${count})`
  return (
    <ContentWrapper>
      <Link to={`/tags/${kebabCase(name)}/`}>{name}{countText}</Link>
    </ContentWrapper>
  )
}

TagItem.propTypes = {
  name: PropTypes.string.isRequired,
  count: PropTypes.number,
}

TagItem.defaultProps = {
  count: 0,
}

export default TagItem
